import { GroupType } from '../api/api';
import { Nullable } from './common';
import { TransformedGroupPackage, TransformedGroupsPackage } from './Groups';

export enum TabType {
  GroupDetails = 'Group Details',
  BenefitGroups = 'Benefit groups',
  Contacts = 'Contacts',
  Logos = 'Logos'
}

export interface TerminationData {
  end_dt: Date;
  terminateReason: string;
  customReason: string;
}

export interface CancelChangesModalProps {
  onCancel: () => void;
  onSubmit: () => void;
}

export interface DeleteDraftModalProps {
  onSubmit: () => void;
  onCancel: () => void;
  groupName: string;
}

export interface ConfirmPublishModalProps {
  onSubmit: () => void;
  onCancel: () => void;
  groupName: string;
}

export interface TerminateModalProps {
  onSubmit: (data: any) => void;
  onCancel: () => void;
  data: [string, Nullable<Date>, TransformedGroupPackage[]];
}

export interface GroupsFormProps {
  defaultValues: TransformedGroupsPackage;
  type: GroupType;
  onDraftDelete: () => void;
  onSaveAsDraft: (data: Partial<TransformedGroupsPackage>) => void;
  onPublish: (data: TransformedGroupsPackage) => void;
}
